import { useParams, Link } from "react-router-dom";

const PAGES: Record<string, { title: string; body: string[] }> = {
  terms: {
    title: "Terms of Service",
    body: [
      "AleaEdge provides informational sports analytics for entertainment purposes only.",
      "By using the service you agree not to rely on any content as a guarantee of outcome. All wagers are made at your own risk.",
      "Subscriptions renew automatically until cancelled in your account settings.",
      "Full terms available on request — contact support@aleaedge.com.",
    ],
  },
  privacy: {
    title: "Privacy Policy",
    body: [
      "We collect the minimum data required to operate the service: email, authentication data, subscription status, and usage analytics.",
      "We do not sell personal information. Payment processing is handled by Stripe under their privacy policy.",
      "You may request data export or deletion at any time by emailing support@aleaedge.com.",
    ],
  },
  "responsible-gambling": {
    title: "Responsible Gambling",
    body: [
      "AleaEdge content is informational only and is not advice to wager. You must be of legal age in your jurisdiction.",
      "If gambling is no longer fun, take a break. Set deposit, time and loss limits with your sportsbook.",
      "US help: National Council on Problem Gambling — 1-800-GAMBLER.",
      "If you or someone you know has a problem, please seek help immediately.",
    ],
  },
};

export default function Legal() {
  const { slug } = useParams();
  const page = slug ? PAGES[slug] : undefined;
  if (!page) {
    return (
      <div className="container py-16">
        <h1 className="font-display text-3xl font-bold">Page not found</h1>
        <Link to="/" className="text-primary underline mt-4 inline-block">Back to home</Link>
      </div>
    );
  }
  return (
    <div className="container max-w-3xl py-12">
      <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight">{page.title}</h1>
      <p className="text-xs uppercase tracking-wider text-muted-foreground mt-2">Last updated {new Date().toLocaleDateString("en-US", { month: "long", year: "numeric" })}</p>
      <div className="mt-8 space-y-4 text-sm leading-relaxed text-muted-foreground">
        {page.body.map((p, i) => (
          <p key={i}>{p}</p>
        ))}
      </div>
    </div>
  );
}
